import React from "react";

import { formatPnlBdt, pnlStatusBadgeKey, pnlStatusLabel } from "../../utils/assetManagerPnl";
import { projectTitleWithCode } from "../../utils/projectViews";
import PnlHistoryRowMenu from "./PnlHistoryRowMenu";

export default function PnlHistoryTable({
  rows,
  assignedProjects,
  projectFilter,
  onProjectFilterChange,
  hideProjectFilter = false,
  pnlCancellingId,
  onEdit,
  onCancel,
  emptyMessage = "No P&L submissions yet.",
}) {
  return (
    <>
      {!hideProjectFilter && assignedProjects.length > 1 && (
        <div style={{ marginBottom: 12, maxWidth: 360 }}>
          <label className="muted" style={{ display: "block", fontSize: 12, marginBottom: 4 }} htmlFor="am-pnl-history-project">
            Filter by project
          </label>
          <select
            id="am-pnl-history-project"
            className="compact-field"
            value={projectFilter}
            onChange={(e) => onProjectFilterChange(e.target.value)}
          >
            <option value="">All projects</option>
            {assignedProjects.map((p) => (
              <option key={p.id} value={p.id}>
                {projectTitleWithCode(p)}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="table-wrap table-wrap--allow-menus">
        <table className="ops-table">
          <thead>
            <tr>
              <th>Project</th>
              <th>Reporting period</th>
              <th>Revenue</th>
              <th>Expenses</th>
              <th>Admin fee</th>
              <th>Net P&amp;L</th>
              <th>Fund after P&amp;L</th>
              <th>Submitted</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              const proj = assignedProjects.find((p) => p.id === row.project);
              const projectName =
                row.project_title || (proj ? projectTitleWithCode(proj) : String(row.project || "—"));
              const canModify =
                row.can_edit ?? row.can_cancel ?? String(row.status || "").toUpperCase() === "PENDING";
              const statusKey = pnlStatusBadgeKey(row);
              return (
                <tr key={row.id}>
                  <td>{projectName}</td>
                  <td>
                    {row.period_start} to {row.period_end}
                  </td>
                  <td>{formatPnlBdt(row.revenue)}</td>
                  <td>{formatPnlBdt(row.expenses)}</td>
                  <td>{formatPnlBdt(row.admin_fee)}</td>
                  <td>{formatPnlBdt(row.net_pnl)}</td>
                  <td>{formatPnlBdt(row.updated_fund_value)}</td>
                  <td>{row.submitted_at ? new Date(row.submitted_at).toLocaleString() : "—"}</td>
                  <td>
                    <span className={`badge badge-${statusKey}`}>{pnlStatusLabel(row)}</span>
                  </td>
                  <td>
                    <PnlHistoryRowMenu
                      row={row}
                      canModify={canModify}
                      cancelling={pnlCancellingId === row.id}
                      onEdit={onEdit}
                      onCancel={onCancel}
                    />
                  </td>
                </tr>
              );
            })}
            {rows.length === 0 && (
              <tr>
                <td colSpan={10} className="muted">
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}


